export const SUPPORTED_SALARY_CSV_CATEGORY_IDS = [
  'fc53ff68-c24c-49fd-a871-dbde1e458cbd', // Salary: SGA-ADMIN-009
  '3cd24426-3e63-40d8-8d8a-dffc346e0a57', // Warehouse Salary: COGS-WH-SALARY
  '8c34e581-6e58-4446-aa40-9dfe5e37e202', // Warehouse Overtime: COGS-WH-OT
  '314aaa6c-94a5-4ed9-a7e1-9fb36673b781', // Car Rent (Delivery): COGS-DEL-RENT
  'e34282d3-2c08-4bcc-8130-185bd87d6b2e', // Delivery costs: COGS-DEL-FUEL
  '2d50e8d4-249d-4f21-b0a9-6d688afdefa2', // Salary (Zeami): SGA-ADMIN-COST-010
  'e0b25530-96f2-4f48-acf0-02ae681de4a7', // Salary (Grant): SGA-ADMIN-COST-011
  '939e0809-ff0e-42e1-b49a-deef1704b0bd', // Salary (Export): SGA-ADMIN-COST-012
] as const;

export const isSupportedSalaryCsvCategory = (
  categoryId?: string | null
) => {
  return !!categoryId && SUPPORTED_SALARY_CSV_CATEGORY_IDS.includes(categoryId as (typeof SUPPORTED_SALARY_CSV_CATEGORY_IDS)[number]);
};